import { render, staticRenderFns } from "./AddNewFileModal.vue?vue&type=template&id=2817ca27&scoped=true"
import script from "./AddNewFileModal.vue?vue&type=script&lang=js"
export * from "./AddNewFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817ca27",
  null
  
)

export default component.exports